if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[name="add"]') || this.querySelector('button[type="submit"]') || this.querySelector('button[type="button"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // FIX: Écouter UNIQUEMENT le clic sur le bouton
        this.submitButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (this.submitButton.getAttribute('aria-disabled') !== 'true') {
            this.onSubmitHandler(e);
          }
        });
      }

      onSubmitHandler(evt) {
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);

    // ↓ OUVERTURE IMMÉDIATE avant la requête réseau
    this.cart.open(this.submitButton);
  }
  config.body = formData;
  if (this.cart) {
  this.cart.open(this.submitButton);

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
  // Fermer le drawer (ouvert prématurément, rien n'a été ajouté)
  if (this.cart && this.cart.classList.contains('active')) {
    this.cart.close();
  }

  publish(PUB_SUB_EVENTS.cartError, {
    source: 'product-form',
    productVariantId: formData.get('id'),
    errors: response.errors || response.description,
    message: response.message,
  });

  // Afficher "Quantité insuffisante" clairement
  this.handleErrorMessage('Quantité insuffisante');

  // Réactiver le bouton après 3s pour permettre une nouvelle tentative
  this.error = false; // ne pas bloquer définitivement
  setTimeout(() => {
    this.handleErrorMessage(false);
  }, 3000);

  return;
}


      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        });
      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
      .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });
  }  // ferme if (this.cart)
}    // ferme onSubmitHandler  ← cette ligne manquait


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}